import { QuestionCircleOutlined } from '@ant-design/icons'
import { HelpDrawer } from '@BUP/components/Generics/help-drawer'
import { UtilsContext } from '@BUP/contexts/utils-context'
import { Button, Form, Input, Select, Skeleton } from 'antd'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function ComplaintEntryFormInputs () {
  const i18n = useTranslation()
  const { data, isLoading } = useContext(UtilsContext)
  const [open, setOpen] = useState(false)
  const [selectedType, setSelectedType] = useState()
  const showTooltip = () => setOpen(true)
  const closeTooltip = () => setOpen(false)

  let typeSuffixIcon, typeHelpDrawer
  if (selectedType && i18n.t(`common.resources.complaint-entry.values.type.${selectedType}.help`, { returnDetails: true }).usedLng !== 'dev') {
    typeSuffixIcon = <Button type='link' onClick={showTooltip}><QuestionCircleOutlined /></Button>
    typeHelpDrawer = <HelpDrawer prefix={`common.resources.complaint-entry.values.type.${selectedType}`} title={i18n.t(`common.resources.complaint-entry.values.type.${selectedType}.label`)} open={open} onClose={closeTooltip} />
  }

  return (
    <Skeleton active loading={isLoading}>
      <Form.Item
        name='type'
        label={i18n.t('common.resources.complaint-entry.attributes.type.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint-entry.attributes.type.validations.required') }]}
      >
        <Select
          options={data.complaint.entry.types.map(type => ({ value: type, label: i18n.t(`common.resources.complaint-entry.values.type.${type}.label`) }))}
          onSelect={setSelectedType}
          suffixIcon={typeSuffixIcon}
        />
      </Form.Item>
      <Form.Item
        name='title'
        label={i18n.t('common.resources.complaint-entry.attributes.title.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint-entry.attributes.title.validations.required') }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name='content'
        label={i18n.t('common.resources.complaint-entry.attributes.content.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint-entry.attributes.content.validations.required') }]}
      >
        <Input.TextArea />
      </Form.Item>
      {typeHelpDrawer}
    </Skeleton>
  )
}
